import { ChangeEvent, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import RegInputWrapper from "../../StylesWrappers/General/regInputBox";
import RegWrapper from "../../StylesWrappers/registeration/register";
import { AppDispatch, RootState } from "../../store";
import InputBox from "../General/InputBox";
import ButtonWrapper from "../../StylesWrappers/General/button";
import Logo from "../General/Logo";
import { getRegValues, reg } from "../../features/registration/registerSlice";
import Button from "../General/Button";
import ToggleShowPassword from "../General/toggleShowPassword";
import TitleText from "../General/Helmet";
import { checkPassword } from "../../utils/passwordCheck";
import { RegState } from "../../model";
import { toastMessage } from "../../utils/toastMessage";

export interface RegProp {
  setToggleReg: React.Dispatch<React.SetStateAction<boolean>>;
}

const Reg = ({ setToggleReg }: RegProp) => {
  const { user, isLoading, isDisable } = useSelector(
    (store: RootState) => store.regStore
  );

  // State to control the show password
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const { firstName, lastName, username, email, password } = user;

  const dispatch = useDispatch<AppDispatch>();

  // Handle Registeration input change
  const handleRegChange = (e: ChangeEvent<HTMLInputElement>) => {
    let name = e.target.name as keyof RegState;
    let value = e.target.value;
    dispatch(getRegValues({ name, value }));
  };

  // Handle click of Register button
  const handleRegSubmit = async (e: React.FormEvent<Element>) => {
    e.preventDefault();

    const checkPass = checkPassword(password);

    if (!firstName || !lastName || !email || !username || !password) {
      toastMessage("No field should be empty", dispatch, toast.error);
      return;
    }
    // Check if password contains password condition
    if (checkPass) {
      toastMessage(
        "Password should contain at least one small case, uppercase, number and special character",
        dispatch,
        toast.error
      );
      return;
    }
    // Register a user when reg submit button clicked
    dispatch(reg({ user, setToggleReg }));
  };

  return (
    <RegWrapper>
      <TitleText title="Register" />
      <RegInputWrapper>
        <Logo />
        <p>Register</p>
        <InputBox
          jobName="First Name"
          typeName="text"
          inputName="firstName"
          inputValue={firstName}
          handleChange={handleRegChange}
        />
        <InputBox
          jobName="Last Name"
          typeName="text"
          inputName="lastName"
          inputValue={lastName}
          handleChange={handleRegChange}
        />
        <InputBox
          jobName="Username"
          typeName="text"
          inputName="username"
          inputValue={username}
          handleChange={handleRegChange}
        />
        <InputBox
          jobName="Email"
          typeName="email"
          inputName="email"
          inputValue={email}
          handleChange={handleRegChange}
        />

        <div
          style={{
            position: "relative",
          }}
        >
          <InputBox
            jobName="Password"
            typeName={`${showPassword ? "text" : "password"}`}
            inputName="password"
            inputValue={password}
            handleChange={handleRegChange}
            autoComplete="current-password"
          />
          <ToggleShowPassword
            password={password}
            setShowPassword={setShowPassword}
            showPassword={showPassword}
          />
        </div>

        <ButtonWrapper>
          <Button
            button="Submit"
            handleSubmit={handleRegSubmit}
            type="submit"
            allJobsBtn={`reg__btn ${isLoading ? "loading__state" : ""}`}
            allLoading={isLoading}
            allDisable={isDisable}
          />
        </ButtonWrapper>
        <footer>
          <p>
            Already a member?{" "}
            <span onClick={() => setToggleReg(true)}>Login</span>
          </p>
        </footer>
      </RegInputWrapper>
    </RegWrapper>
  );
};

export default Reg;
